import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Check = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.67803 17.9992C8.06803 17.9992 7.46803 17.7392 7.07803 17.2492L4.13803 13.5792C3.91803 13.3092 3.96803 12.9192 4.23803 12.7092C4.50803 12.4992 4.89803 12.5392 5.11803 12.8092L8.05803 16.4792C8.29803 16.7792 8.78803 16.8392 9.13803 16.6292C9.18803 16.5992 9.23803 16.5592 9.27803 16.5192L18.918 6.19923C19.158 5.94923 19.548 5.92923 19.798 6.16923C20.048 6.39923 20.068 6.79923 19.828 7.04923L10.178 17.3592C10.068 17.4792 9.93803 17.5792 9.79803 17.6692C9.44803 17.8892 9.05803 17.9992 8.66803 17.9992H8.67803Z" />
  </svg>
)

export default withDefaultStyles(Check)
